import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { ActivityAge } from '../../../../../core';

@JsonConverter
export class ActivityAgeAdapter implements JsonCustomConvert<ActivityAge | undefined> {
    serialize(activityAge: ActivityAge): any | undefined {
        return activityAge ? String(activityAge) : undefined;
    }

    deserialize(activityAge: any): ActivityAge | undefined {
        switch (activityAge) {
            case '1C':
                return ActivityAge.LESS_1_YEAR;
            case '2C':
                return ActivityAge.BETWEEN_1_5_YEARS;
            case '3C':
                return ActivityAge.BETWEEN_5_10_YEARS;
            case '4C':
                return ActivityAge.MORE_10_YEARS;
            default:
                return undefined;
        }
    }
}
